import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));
const TITLE = "كم باقي على كأس العالم 2026 - العد التنازلي لكأس العالم";
const DESCRIPTION = "كم باقي على كأس العالم 2026؟ العد التنازلي لكأس العالم FIFA يوفر لك معلومات دقيقة حول موعد بداية المونديال، وكم يوم متبقي لانطلاق الحدث الكروي الأكبر في العالم. تابع العد التنازلي لكأس العالم وتعرف على المدة المتبقية حتى بدء المنافسات.";
const KEYWORDS = "كأس العالم 2026, كم باقي على كأس العالم, العد التنازلي لكأس العالم, متى كأس العالم, مونديال 2026, كأس العالم العد التنازلي, موعد كأس العالم, مباريات كأس العالم, FIFA 2026";
const OG_URL = "https://do-calculate.com/articles-ar/worldcup";
function WorldCupCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const worldCupDate = new Date("2026-06-08T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(worldCupDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(worldCupDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    return (
        <div className="rtl">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>كم باقي على كأس العالم 2026</h1>
            <Suspense fallback={<div>Loading...</div>}>
                <BlinkingText text="كم باقي على كأس العالم: من المتوقع أن تبدأ البطولة يوم الإثنين 8 يونيو 2026 في الولايات المتحدة، كندا، والمكسيك." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <thead>
                            <tr>
                                <th>يوم</th>
                                <th>ساعة</th>
                                <th>دقيقة</th>
                                <th>ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days}</td>
                                <td>{timeLeft.hours}</td>
                                <td>{timeLeft.minutes}</td>
                                <td>{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>معلومات عن كأس العالم 2026</h3>
                    <p>
                        كأس العالم لكرة القدم هو الحدث الرياضي الأكثر شعبية في العالم، حيث تتنافس المنتخبات الوطنية للفوز باللقب الأغلى في تاريخ الكرة. كأس العالم 2026 سيكون مميزًا للغاية لأنه سيُقام لأول مرة في ثلاث دول مختلفة: الولايات المتحدة، كندا، والمكسيك. يترقب عشاق كرة القدم هذا الحدث بكل شغف، حيث ستشهد البطولة مشاركة 48 منتخبًا لأول مرة في التاريخ، ما يجعل المنافسة أقوى وأكبر.
                    </p>
                    <p>
                        تعد النسخة القادمة من كأس العالم محطة هامة في تاريخ البطولة، حيث ستكون أول نسخة بتوسع جديد في عدد المنتخبات، مما يتيح فرصًا أكبر للفرق الوطنية للمشاركة وتحقيق إنجازات جديدة.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Loading...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col">
                    <Suspense fallback={<div>Loading...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
export default WorldCupCountdown;
